import React from "react";
import cn from "classnames";
import { i18n } from "@src/i18n/i18n";
import { Icon } from "@components/atoms/icon/icon";
import styles from "./help-icon-button.module.scss";

interface HelpIconButtonPropTypes {
  ariaLabel?: string;
  iconName: string;
  isIconActive: boolean;
  height?: number;
  width?: number;
  handleClick: () => void;
}

const DEFAULT_ARIA_LABEL = i18n("modules.helpButton.tooltip");
const DEFAULT_ICON_NAME = "question_mark";
const DEFAULT_HEIGHT = 24;
const DEFAULT_WIDTH = 24;

const cssClassName = "help-icon-button";

export const HelpIconButton = ({
  ariaLabel = DEFAULT_ARIA_LABEL,
  iconName = DEFAULT_ICON_NAME,
  isIconActive,
  height = DEFAULT_HEIGHT,
  width = DEFAULT_WIDTH,
  handleClick,
}: HelpIconButtonPropTypes) => (
  <button
    type="button"
    className={cn(
      styles[cssClassName],
      styles[`${cssClassName}__hover`],
      styles[`${cssClassName}__center-content`],
      {
        [styles[`${cssClassName}__active`]]: isIconActive,
      },
    )}
    onClick={handleClick}
    aria-label={ariaLabel}
  >
    <Icon name={iconName} width={width} height={height} />
  </button>
);
